import { combineReducers } from 'redux';

import bandwidthReducer from './bandwidth/bandwidthReducer';

export default combineReducers({
	bandwidth: bandwidthReducer,
});
